var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBugzilla(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 110 90",
    style: {
      enableBackground: "new 0 0 110 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);stroke:#625874;stroke-width:0.99;}\r\n\t.st1{fill:#363433;}\r\n\t.st2{fill:#F6DAAA;stroke:#363433;stroke-width:1.3;stroke-linecap:square;}\r\n\t.st3{fill:none;stroke:#6D6E6E;stroke-width:0.5;stroke-linecap:square;}\r\n\t.st4{fill:url(#SVGID_2_);stroke:#363433;stroke-width:1.3;stroke-linecap:square;}\r\n\t.st5{fill:#F6DAAA;}\r\n\t.st6{fill:url(#SVGID_3_);}\r\n\t.st7{fill:#FFFFFF;stroke:url(#SVGID_4_);stroke-width:0.75;stroke-linecap:square;}\r\n\t.st8{fill:#343231;}\r\n\t.st9{fill:#FFFFFF;}\r\n\t.st10{fill:url(#SVGID_5_);}\r\n\t.st11{fill:#413F3E;}\r\n\t.st12{fill:#E67E71;}\r\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bugzilla_tech"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -11.9985,
    y1: 26.944,
    x2: -11.9985,
    y2: 27.4451,
    gradientTransform: "matrix(88.01 0 0 88.01 1110.9879 -2340.3083)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#8A7AB9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B888B6"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34,31h42c0.5,0,1,0.4,1,1v42c0,0.5-0.4,1-1,1H34c-0.5,0-1-0.4-1-1V32C33,31.5,33.5,31,34,31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48.8,61.6c-11.1,0-12.2,10.9-12.2,13.1h23.6C60.1,72.3,59.7,61.6,48.8,61.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M68.6,43.4c0.1,6.1-7.4-2.6-6.4-6.3c0.6-0.7,1.5-1.2,2.4-1.2C65.5,35.9,67.9,39.9,68.6,43.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M52.7,37.8c4.2-10.7,2.3-21-1.5-22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: -12.1381,
    y1: 27.3889,
    x2: -12.1938,
    y2: 27.4632,
    gradientTransform: "matrix(60.68 0 0 52.52 787.944 -1379.8344)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6DAAA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E4BC98"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M52.4,37.6c-3.8,0.2-6.8,3.4-6.6,7.3c0,0.2,0,0.4,0.1,0.6c1.7,5.5,2.6,11.2,2.5,16.9c1,1.1,3.9,2.3,5.6,0.5 c-0.5-4.1,2.9-5.2,8-4.9c6.1,0.4,14-1,14-6.8c-0.5-3.7-4.7-6.4-11.3-10.2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M54,36.9c-0.2-5,11.1-14.1,15-9.5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.9,40.5c6.2-7.6,11.9-8.6,16.1,4.1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_3_",
    cx: -11.8682,
    cy: 27.4761,
    r: 0.167,
    gradientTransform: "matrix(16.16 0 0 16.16 263.158 -396.2102)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M69.8,44.4c-2.2,0.8-3.3,3.2-2.5,5.4s3.2,3.3,5.4,2.5c1.2-0.5,2.2-1.5,2.5-2.7c-0.7-1.2-1.6-2.3-2.7-3.1 C71.7,45.7,70.8,45,69.8,44.4z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,56.7c-0.2,0-0.5,0.5-0.1,0.4c2.2-0.4,4.4,0,6.3,1.2h0.2l0.2-0.3l0,0C57.4,56.9,55.1,56.4,52.8,56.7z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: -11.2973,
    y1: 27.6672,
    x2: -11.4082,
    y2: 27.6549,
    gradientTransform: "matrix(17.68 0 0 21.93 256.884 -563.8409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#363433"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#363433",
      stopOpacity: 0
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M55.5,47.4c-0.5-0.4-3-8.5,1.4-9.8c2.8-0.8,6.3,5.5,6.3,8.1C63.2,48.3,57.8,49.5,55.5,47.4z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M59.8,41.3c-0.3,1.6-1.4,2.6-2.5,2.4s-1.7-1.6-1.5-3.2c0.3-1.6,1.4-2.6,2.5-2.4 C59.4,38.4,60.1,39.8,59.8,41.3z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M58.2,40.3c-0.1,0.3-0.4,0.5-0.6,0.6c-0.2,0.1-0.4,0-0.5-0.2c0,0,0,0,0-0.1c-0.1-0.3,0-0.6,0.1-0.9 c0.1-0.3,0.4-0.5,0.7-0.6c0.2-0.1,0.4,0,0.5,0.2c0,0,0,0,0,0.1C58.4,39.7,58.4,40,58.2,40.3z M57.4,42.6c-0.1-0.1-0.1-0.2,0-0.3 c0.1-0.1,0.2-0.1,0.3-0.1c0.1,0,0.2,0.1,0.3,0.2c0.1,0.1,0.1,0.2,0,0.3c-0.1,0.1-0.2,0.1-0.3,0.1C57.6,42.8,57.5,42.7,57.4,42.6z "
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_5_",
    cx: -11.0825,
    cy: 27.4249,
    r: 0.2598,
    gradientTransform: "matrix(19.41 0 0 19.41 262.368 -490.1114)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E4BC98"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F6DAAA",
      stopOpacity: 0
    }
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M52.7,37.9h-0.2c-0.3,0.2-0.3,0.1-0.3,0h-0.2l-0.2,0.2l-0.1,0.2h-0.1l0.1-0.2c0.1-0.1,0.1-0.2,0.2-0.3h-0.1 c-0.1,0.1-0.3,0.2-0.1,0c-2,0.4-3.8,1.6-4.7,3.4c-0.7,1.2-1,2.7-0.8,4.1l0,0c1.7,5.4,2.6,11.1,2.7,16.8c0.6,0.6,1.4,1,2.3,1.2 c0.6,0.1,1.3,0.1,1.9-0.1c0.4-0.4,0.6-0.9,0.8-1.5c0-1.4,0.8-2.7,2.1-3.3l0,0L52.7,37.9z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M51.8,15.8c0,0.4-0.3,0.8-0.8,0.8l0,0c-0.4,0-0.8-0.3-0.8-0.8c0,0,0,0,0,0c0-0.4,0.3-0.8,0.8-0.8 c0,0,0,0,0,0C51.4,15,51.8,15.3,51.8,15.8C51.8,15.8,51.8,15.8,51.8,15.8z M69.8,27.4c0,0.4-0.3,0.8-0.8,0.8s-0.8-0.3-0.8-0.8 l0,0c0-0.4,0.3-0.8,0.8-0.8S69.8,27,69.8,27.4z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M48.2,61.9c-5.8-0.2-9.5,5.7-9.1,5.9c0.4,0.2,1.4-1.5,4.3-3.9C44.8,62.8,48.3,62.4,48.2,61.9L48.2,61.9z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M48.3,63.6c-6.1,2.7-8,7-8.1,11.1h19.2c0-3.3-0.2-7.6-4.9-10.9c-1,0.9-2.4,1.2-3.7,0.9 C49.9,64.5,49,64.1,48.3,63.6L48.3,63.6z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.9,44.6c-0.6-2.6-1.7-5.1-3.2-7.2c-0.9-1.4-2.4-2.4-4-2.7c-1.6-0.1-3.1,0.3-4.4,1.2 c-1.7,1.3-3.2,2.8-4.4,4.6c1.4-1.5,3-2.9,4.7-4.2c1.2-0.9,2.6-1.3,4.1-1.2c1.5,0.3,2.9,1.2,3.7,2.5 C63.9,39.8,65.1,42.1,65.9,44.6z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugzilla);
export default __webpack_public_path__ + "static/media/Bugzilla.a7b299a64dabde8187ad62398e1d2b97.svg";
export { ForwardRef as ReactComponent };